const EmployeeMenuItems = [
];

export default EmployeeMenuItems;